import React from 'react';

interface LogoProps {
  className?: string;
  width?: number;
  height?: number;
}

const Logo: React.FC<LogoProps> = ({ 
  className = '', 
  width = 180, 
  height = 50 
}) => {
  return (
    <div className={`logo-container ${className}`} style={{ width, height }}>
      <img 
        src="/AiDA Logo.jpg" 
        alt="AiDA Logo" 
        className="logo-image"
        style={{ maxWidth: '100%', maxHeight: '100%' }}
      />
    </div>
  );
};

export default Logo;
